<template>
    <b-modal v-model="modal.show"
             hide-footer
             centered
             :no-close-on-backdrop="true"
             size="lg"
             :title="(editing ? 'Editar' : 'Crear') + ' Tarea' "
    >
        <el-steps :active="modal.step"
                  align-center
                  finish-status="success"
        >
            <el-step title="Proceso"
                     description="General"
            />
            <el-step title="Tarea"
                     description="Paso a paso"
            />
            <el-step title="Controles"
                     description="Técnicos"
            />
        </el-steps>

        <task v-if="modal.step === 0"/>

        <steps v-if="modal.step === 1"/>

        <controls v-if="modal.step === 2"/>
    </b-modal>
</template>


<script>
import {mapState} from 'vuex';
import steps from './steps.vue';
import controls from './controls.vue';
import task from './task.vue';

export default {
    name: 'modal',
    components: {
        steps,
        controls,
        task
    },
    computed: {
        ...mapState('tasks', [
            'task',
            'editing',
            'modal'
        ])
    }
};
</script>

<style>
.translate-enter-active,
.translate-leave-active {
    transition: all 0.5s ease;
}

.translate-enter-from,
.translate-leave-to {
    opacity: 0;
    transform: translateX(30px);
}
</style>
